import type { Task } from '../../sidebar/models/Task';

export const ASSET_VERSIONING_EXPERIMENT = 'asset_versioning';
export const ASSET_VERSION_PARAM = 'asset_version';
export const ASSET_VERSION_SELECT_EVENT = 'bugherd:asset-version-select';

const ASSET_PATH = /\/projects\/(\d+)\/assets\/(\d+)/;

const parseUrl = (url: string) => {
  try {
    return new URL(url, window.location.origin);
  } catch {
    return null;
  }
};

export const getAssetFeedbackLocation = (url: string) => {
  const match = parseUrl(url)?.pathname.match(`^${ASSET_PATH.source}/?$`);
  return match ? { projectId: +match[1], assetId: +match[2] } : null;
};

export const getCurrentAssetFeedbackLocation = (pageUrl: string) => {
  try {
    return (
      getAssetFeedbackLocation(pageUrl) ||
      getAssetFeedbackLocation(window.location.href) ||
      getAssetFeedbackLocation(window.parent.location.href)
    );
  } catch {
    return getAssetFeedbackLocation(pageUrl) || getAssetFeedbackLocation(window.location.href);
  }
};

export const getAssetFeedbackPath = (url: string) => {
  const loc = getAssetFeedbackLocation(url);
  return loc && `/projects/${loc.projectId}/assets/${loc.assetId}`;
};

export const getExplicitAssetVersion = (url: string) => {
  const version = Number(parseUrl(url)?.searchParams.get(ASSET_VERSION_PARAM));
  return version > 0 ? version : null;
};

export const getAssetVersion = (url: string) => getExplicitAssetVersion(url) || 1;

export const isAssetFeedbackTask = (task: Task, assetId?: number | null) =>
  assetId
    ? Number(task.assetId) === assetId ||
      getAssetFeedbackLocation(task.url || '')?.assetId === assetId
    : Number(task.assetId) > 0 || ASSET_PATH.test(task.url || '');

export const withAssetVersionParam = (url: string, version: number) => {
  const parsed = parseUrl(url);
  if (!parsed) {
    return `${url}${url.includes('?') ? '&' : '?'}${ASSET_VERSION_PARAM}=${version}`;
  }
  parsed.searchParams.set(ASSET_VERSION_PARAM, String(version));
  return `${parsed.pathname}${parsed.search}`;
};

export const taskMatchesAssetVersions = (
  task: Task,
  assetId: number | null,
  versions: number[] | null
) =>
  !versions ||
  (task.assetId === assetId && versions.includes(getAssetVersion(task.url)));
